const state = {
  previewType: '', // global | scene
  isProcessing: false,
  url: void 0,
  reader: ''
}

const getters = {
  PreviewType: state => state.previewType,
  IsDoingSmartVoice: state => state.isProcessing,
  SmartVoicePreviewUrl: state => state.url,
  AIReader: state => state.reader
}

const mutations = {
  set_PreviewType (state, data) {
    state.previewType = data;
  },
  set_IsDoingSmartVoice (state, data, url) {
    state.isProcessing = data.flag;
    state.url = data.url;
  },
  set_Reader (state, data) {
    state.reader = data;
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/voiceAI.js